import { BtnTooltipController } from "./btn-tooltip.controller";

angular
    .module("thor.shared.btn-tooltip.component", [])
    .component("btnTooltip", {
        bindings: {
            class: "@",
            icon: "@",
            position: "@",
            tooltip: "@"
        },
        controller: BtnTooltipController,
        template: require("./btn-tooltip.html")
    });
